import {useContext, useEffect} from 'react';
import {CommonLayoutContext} from 'layouts/CommonLayout/context';
import style from 'components/UpButton/style.module.scss';

export function useUpButtonOffsetForStickyPanel(): void {
    const {setUpButtonClassName} = useContext(CommonLayoutContext);

    useEffect(() => {
        setUpButtonClassName?.(style.offsetSticky);
        return () => {
            setUpButtonClassName?.(undefined);
        };
    }, [setUpButtonClassName]);
}
